import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Fixtures from "@/pages/Fixtures";
import Predictions from "@/pages/Predictions";
import Leagues from "@/pages/Leagues";
import SportPage from "@/pages/SportPage";
import Leaderboard from "@/pages/Leaderboard";
import SignUp from "@/pages/SignUp";
import Admin from "@/pages/Admin";
import { getUser } from "@/lib/storage";

function App() {
  const [user, setUser] = useState(getUser());
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    setUser(getUser());
    setAuthReady(true);
    const handler = () => setUser(getUser());
    window.addEventListener("auth-updated", handler);
    return () => window.removeEventListener("auth-updated", handler);
  }, []);

  if (!authReady) return null;

  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#111827",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#f1f5f9",
            fontFamily: "'DM Sans', sans-serif",
          },
        }}
      />
      <Routes>
        <Route path="/signup" element={user ? <Navigate to="/" /> : <SignUp />} />
        {user ? (
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/fixtures" element={<Fixtures />} />
            <Route path="/predictions" element={<Predictions />} />
            <Route path="/leagues" element={<Leagues />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/sport/:category" element={<SportPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/signup" />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
